module.exports = __webpack_public_path__ + "media/bootstrap-icons/mouse3-fill-d0accb53.svg";